export const components = [
  'AntEmpty',
  'AntSkeleton',
  'AntSkeleton/AntBlockSkeleton',
  'AntSkeleton/AntPolySkeleton',
  'AntForm',
  'AntFormItem',
  'AntFormItem/AntTagInput',
  'AntSkeleton/AntGridSkeleton',
  'AntMenu',
  'AntMenu/SideMenu',
  'AntMenu/StandardMenu',
  'AntBreadcrumb',
  'AntPagin',
  'Banner',
  'Swipers',
  'Conditions',
  'Catalogue',
  'Card/Comprehensive',
  'Card/Threshold',
  'Card/Standard',
  'Card/Payment',
  'Card/Announcement',
  'Html',
  'Iframe',
  'Lottie',
  'OrderTable',
  'Render',
  'RelevantStandard',
  'Share',
  'Screen',
  'Tabs',
  'TwoDimensionalCode'
];

// A、B、C、D、E、F、G、H、I、J、K、L、M、N、O、P、Q、R、S、T、U、V、W、X、Y、Z